import {
    BaseContainer,
    BaseTitle,
    BaseIconContainer,
    BaseButtonContainer,
    BaseMessageContainer,
    BaseMessage
} from '../masterBase/styles';

export const Container = BaseContainer;
export const Title = BaseTitle;
export const IconContainer = BaseIconContainer;
export const MessageContainer = BaseMessageContainer;
export const Message = BaseMessage;
export const ButtonContainer = BaseButtonContainer;
